import React from "react";
import appContext from "../../../appContext";
import LogicsSettingsDialog from "../../CreateForm/DialogBase/LogicsSettingsDialog";

import { ThemeProvider } from "@mui/styles";
import { Box, createTheme, Divider } from "@mui/material";
import { hasFieldContainsName } from "../../Slides/utils";
import { optionModeConstants, systemFields } from "../../../Utils/common";

import {
  AdvancedSettingsButton,
  BackToBasicSettingsButton,
  LogicsButton,
} from "../../Custom/Buttons";

import {
  RootContainer,
  HeaderContainer,
  BodyContainer,
  TypeContainer,
  SettingsContainer,
  OptionsContainer,
  StylesContainer,
  QuestionHeaderContainer,
} from "./styled";

interface OptionalComponentsProps {
  hasOptions: Boolean;
  selectedType: string;
  hasSelectOrMultiSelect: Boolean;
  renderOptions: () => React.ReactNode;
  renderQuantity: () => React.ReactNode;
  renderSettings: () => React.ReactNode;
  renderStyles: () => React.ReactNode;
  renderType: () => React.ReactNode;
  allQuestionFormData: any;
  setQuestionFormData: (value: any) => void;
  setAllValues: (e: any) => void;
  setSelectedData: (e: any) => void;
  historyState: any;
}

const theme = createTheme({
  spacing: 4,
});

export default function OptionalComponents({
  hasOptions,
  selectedType,
  hasSelectOrMultiSelect,
  renderOptions,
  renderQuantity,
  renderSettings,
  renderStyles,
  renderType,
  allQuestionFormData,
  setQuestionFormData,
  setAllValues,
  setSelectedData,
  historyState,
}: OptionalComponentsProps) {
  const { optionMode, setOptionMode, openLogicDialog, setOpenLogicDialog } =
    React.useContext(appContext);

  const isFieldContainsName = React.useMemo(() => {
    return hasFieldContainsName(selectedType);
  }, [selectedType]);

  const handleOpenLogicDialog = () => {
    setOpenLogicDialog(true);
  };

  const handleCloseLogicDialog = () => {
    setOpenLogicDialog(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <RootContainer>
        <QuestionHeaderContainer>
          <HeaderContainer>Question</HeaderContainer>
          <LogicsButton
            disabled={historyState.length}
            onClick={handleOpenLogicDialog}
          />
        </QuestionHeaderContainer>
        <Divider />
        <BodyContainer>
          <LogicsSettingsDialog
            open={openLogicDialog}
            closeHandler={handleCloseLogicDialog}
            allQuestionFormData={allQuestionFormData}
            setQuestionFormData={setQuestionFormData}
            setAllValues={setAllValues}
            setSelectedData={setSelectedData}
          />
          <TypeContainer>{renderType()}</TypeContainer>
          <SettingsContainer>
            <HeaderContainer>Settings</HeaderContainer>
            <Divider />
            {renderSettings()}
          </SettingsContainer>
          {hasOptions && (
            <React.Fragment>
              <OptionsContainer>
                <Box
                  component="div"
                  display="flex"
                  justifyContent="space-between"
                >
                  <HeaderContainer>Options</HeaderContainer>
                  {isFieldContainsName ? (
                    optionMode === optionModeConstants.basic ? (
                      <AdvancedSettingsButton
                        disabled={systemFields.includes(selectedType)}
                        onClick={() =>
                          setOptionMode(optionModeConstants.advanced)
                        }
                      />
                    ) : (
                      <BackToBasicSettingsButton
                        onClick={() => setOptionMode(optionModeConstants.basic)}
                      />
                    )
                  ) : (
                    <React.Fragment />
                  )}
                </Box>
                <Divider />
                {renderOptions()}
              </OptionsContainer>
              {hasSelectOrMultiSelect && (
                <OptionsContainer>
                  <HeaderContainer>Quantity</HeaderContainer>
                  <Divider />
                  {renderQuantity()}
                </OptionsContainer>
              )}
            </React.Fragment>
          )}
          <StylesContainer>
            <HeaderContainer>Styles</HeaderContainer>
            <Divider />
            {renderStyles()}
          </StylesContainer>
        </BodyContainer>
      </RootContainer>
    </ThemeProvider>
  );
}
